<template>
	<div class="my-1">
		<v-tooltip
			top
			:open-on-click="true"
			:open-on-focus="true"
			:open-on-hover="true"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-chip v-bind="attrs" v-on="on">
					<v-icon color="primary">mdi-alert</v-icon>
					{{ formField.Label }} : {{ value }}
				</v-chip>
			</template>
			Value automatically generated
		</v-tooltip>
	</div>
</template>

<script>
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
import { FieldDataTypes } from '../../../../enums/fieldDataTypes';
export default {
	name: 'AutoGeneratedFormField',
	mixins: [formFieldMixin, projectSettingsMixin],
	methods: {
		onRecordChanged() {
			//DO Nothing;just prevent console error;
		},
		onSetInteraction() {},
		onClearInteraction() {},
	},
	computed: {
		value() {
			if (
				this.formField.GridViewFields[0].DataFieldType ===
				FieldDataTypes.AUTOGENERATED_DATETIME
			)
				return this.getDateTimeFormat(this.recordSelectedValue);
			return this.recordSelectedValue;
		},
	},
};
</script>
